import React from 'react';

const ViewToggle = ({ mode, onDay, onWeek, onMonth }) => (
    <div className="pc-sched-seg">
        <button type="button" className={mode === 'day' ? 'on' : ''} onClick={onDay}>День</button>
        <button type="button" className={mode === 'week' ? 'on' : ''} onClick={onWeek}>Неделя</button>
        <button type="button" className={mode === 'month' ? 'on' : ''} onClick={onMonth}>Месяц</button>
    </div>
);

export default ViewToggle;
